<template>




    <div class="row">  
                    


        <div class="col-lg-12">
            <h3 class="entry-title"> <i class="fas fa-lock"></i> Weryfikacja konta </h3>   
        </div> 


        <div class="wrap column row justify-content-between d-none d-md-flex">
            

           
            <div id="kontomatik" class="column col-12" />



                <div class="form-group form-btn-wrap column col-10 col-mx-auto">

                    <input type="button" key="btn-main" class="button btn-prev" @click="gotomain" value="Powrót" />              
                       
                </div>


            </div>
        
        </div>

    </div>





</template>

<script>

    
    import DynamicForm from './DynamicForm'

    export default {
     
       name: 'ZetosKontoxView',


       components: { DynamicForm },


       methods: {


        gotomain(){


            this.$router.push({path: '/'});

        }
       },


       mounted() {


            // index.js
            embedKontomatik({
              client: 'psfloans-test',  // replace it with your assigned client id
              divId: 'kontomatik',       // must match the div element id
              locale: 'pl',  
              onSuccess: function(target, sessionId, sessionIdSignature, options) {
                // End-user successfully signed in to the bank
                // Pass target, sessionId and sessionIdSignature to your backend
                //alert('It works!');


                console.log("session_id " + sessionId);
                console.log("session_id_signature " + sessionIdSignature);
              }
            });





/*setTimeout(() => {
     
 var elems = document.getElementsByTagName('iframe');

                for (var i = 0; i<elems.length; i++) {
                   
                        elems[i].style.maxWidth = 'auto';
                    
                }




    }, 500);

          */ 

       }



        
    }
</script>



<style scoped>

h3 i {
    color: #0bc268;
}

.entry-title {


    font-size:32px;
    margin: 2.8em 0 2em;

    text-align: center;

}







</style>


// WEBPACK FOOTER //
// src/ZetosKontoxView.vue